export default "__VITE_ASSET__DJEvVGxu__"